import { gql } from '@apollo/client'

const UPDATE_COURSE_TYPE_DETAILS_MUTATION = gql`
  mutation updateCourseTypeDetails($id: ID!, $data: CourseTypeDetailsInput!) {
    updateCourseTypeDetails(id: $id, data: $data) {
      id
      description
      position
      updatedAt
      updatedBy {
        id
        name
      }
      isDefaultFilter
      isIgnored
      isExcludedFromSearch
      synonyms
      rearrangementScore
    }
  }
`

export default UPDATE_COURSE_TYPE_DETAILS_MUTATION
